<template>
  <Grid gtc="1fr 1fr 1fr" gtr="250px auto auto" gap="var(--r-space-sp) var(--r-space-md)" class="usage">
    <Widgets v-if="$store.state.widgets.layout.length" :key="widgetsRenderer" />

    <Grid v-else place-items="center" class="q-pa-xl" style="grid-column: span 3">
      <q-spinner color="primary" size="2rem" />
    </Grid>

    <PriceUsageTable class="price-usage-table" @table-updated="widgetsRenderer++" />

    <Grid gtc="1.5fr 1fr" gap="var(--r-space-sp) var(--r-space-md)" align-items="start" class="third-row">
      <Notes :entity="{ name: 'subscription', id }" store-namespace="subscriptions" />
      <Grid gap="var(--r-space-md)">
        <Attachments :entity="{ name: 'subscription', id }" store-namespace="subscriptions" />

        <Links
          ref="links"
          :dropdown-initial-value="linksCategories"
          :entity="{ name: 'subscription', id }"
          store-namespace="subscriptions"
        />
      </Grid>
    </Grid>
  </Grid>
</template>

<script>
// Components
import Widgets from './components/widgets/Widgets'
import PriceUsageTable from './components/price-usage-table/PriceUsageTable'
import Notes from '@components/lm-blocks/Notes'
import Links from '@components/lm-blocks/Links'
import Attachments from '@components/lm-blocks/Attachments'
import { linksCategories } from '@/reusable/data/links-categories'

export default {
  components: {
    Widgets,
    PriceUsageTable,
    Notes,
    Links,
    Attachments
  },

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    widgetsRenderer: 1,
    alreadyVisitedOnce: false
  }),

  computed: { linksCategories },

  created() {
    this.$store.dispatch('widgets/getContext')
  },

  activated() {
    if (this.alreadyVisitedOnce) this.$refs.links.getLinks()
    else this.alreadyVisitedOnce = true
  }
}
</script>

<style lang="scss" scoped>
.usage {
  > .widgets,
  > .price-usage-table,
  > .third-row {
    grid-column: span 3;
  }
}
</style>
